export const buildOptimisticShortPost = ({
  author,
  permlink,
  body,
  createdAt,
  jsonMetadata,
  targetPost,
  feedType,
  tags = []
}) => ({
  author,
  permlink,
  body,
  created: createdAt,
  json_metadata: jsonMetadata,
  parentAuthor: targetPost?.author,
  parentPermlink: targetPost?.permlink,
  votes: { total: 0 },
  replies: 0,
  depth: 1,
  optimistic: true,
  optimisticStatus: 'pending',
  optimisticType: 'short_post',
  optimisticFeedType: feedType,
  optimisticTags: tags
});

export const buildOptimisticShortPostUpsertPayload = ({
  author,
  permlink,
  body,
  createdAt,
  jsonMetadata,
  targetPost,
  voteCount = 0,
  replyCount = 0
}) => ({
  author,
  permlink,
  body,
  json_metadata: jsonMetadata,
  parent_author: targetPost?.author,
  parent_permlink: targetPost?.permlink,
  created_at: createdAt || new Date().toISOString(),
  vote_count: voteCount,
  reply_count: replyCount
});
